var token = ((document.getElementById("millermenu")|| {}).dataset || {}).hash

let currentSubObj = {}
// location.origin + `/apps/subscriptions?action=customer_payment_token&customer_id=${window.customer.id}`
let url = location.origin+"/apps/subscriptions/"
const weekday = new Array(7);
weekday[1] = "monday";
weekday[2] = "tuesday";
weekday[3] = "wednesday";
weekday[4] = "thursday";
weekday[5] = "friday";
weekday[6] = "saturday";
weekday[7] = "sunday";
const delivDay = new Array(7);
delivDay[1] = "Sunday";
delivDay[2] = "Monday";
delivDay[3] = "Tuesday";
delivDay[4] = "Wednesday";
delivDay[5] = "Thursday";
delivDay[6] = "Friday";
delivDay[7] = "Saturday";
const chargeDay = new Array(7);
chargeDay[5] = "Sunday";
chargeDay[6] = "Monday";
chargeDay[7] = "Tuesday";
chargeDay[1] = "Wednesday";
chargeDay[2] = "Thursday";
chargeDay[3] = "Friday";
chargeDay[4] = "Saturday";
handleDups = (numberOfDups) => {
  const duplicateSubsHeader = document.querySelector(".skipHeader")
  duplicateSubsHeader.innerHTML = "<h2>Uh oh, you have more than one active subscription</h2>"
  const dupSubSubheader = document.querySelector(".skipText")
  dupSubSubheader.innerHTML = "<p>Currently we do not support creating multiple subscriptions, and it looks like you have more than one attached to your account. Please cancel the subscriptions you do not need.</p>"
  const hideTheButtons = document.querySelector(".skipNoticeBtns")
  hideTheButtons.style.display = "none"
  const duplicateSubsMessage = document.querySelector(".duplicateSubs")
  duplicateSubsMessage.style = "display:flex; justify-content:center;"
  duplicateSubsMessage.innerHTML += "<button class=\"duplicateSubNav\" onclick=\"location.href = '/apps/subscriptions'\">View Active Subscriptions</button>"
  let usure = document.querySelector('#skipNotice');
  usure.classList.toggle('skipHidden');
 
}

(async function () {
  var res = {};
res = await fetch(location.origin + `/apps/subscriptions?action=customer_payment_token&customer_id=${window.customer.id}`)
res = await res.json();
  var doubleCheckOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  }
  let forProcessor = 0;
  let activeSubCount = 0;
  let fetchedSubs
  const handleWarning = () => {
    if (activeSubCount === 2) {
      console.log("action taken to handle multiple subs")
      handleDups(activeSubCount)
      if (typeof window.clarity === 'function') {
      window.clarity("set", "subscriber_action", "duplicate_subs_notice")
      }
    }
  }
  /* fetch all subscriptions */
  var x = window.customer.id;
    x = (token+x).replace('\n','')
    var hash = CryptoJS.MD5(x).toString();

  var headers ={'headers':
  // APPSTLE REMOVED: Appstle external token disabled
  // {'externalauthorization':`Bearer ${res.appstleExternalToken}`,"Content-Type": "application/json","accept": "application/json, text/plain, */*"},'method':'GET'}
  {"Content-Type": "application/json","accept": "application/json, text/plain, */*"},'method':'GET'}

  fetch( `${url}cp/api/subscription-customers/valid/${res.token}`+`?shop=inspiredgo.myshopify.com`,headers)
  .then(response => response.json())
  .then((data) => {
    fetchedSubs = data.length
    /* check for active subs */
    data.forEach((subscriptionIdentifier) => {
      requestedSubId = subscriptionIdentifier
      forProcessor++
       x = subscriptionIdentifier ;
        x = (token+x).replace('\n','')
     hash = CryptoJS.MD5(x).toString();
      /* Request sub status within loop */
      // APPSTLE REMOVED: Appstle external token disabled
      // doubleCheckOptions['headers']['externalauthorization']=`Bearer ${res.appstleExternalToken}`
      fetch(`${url}cp/api/subscription-contracts/contract-external/` + subscriptionIdentifier + `?shop=inspiredgo.myshopify.com&hash=${hash}&email=`+window.customer.email, doubleCheckOptions)
        .then((response) => response.json())
        .then((data) => {
         
          if (data.status === "ACTIVE") {
            activeSubCount++
            currentSubObj["subCreatedDate"] = data.createdAt.replace(/T.*$/, "")
            currentSubObj["subInterval"] = data.billingPolicy.intervalCount;
            currentSubObj["nextBillingDate"] = data.nextBillingDate
            currentSubObj["nextBillingDay"] = new Date(data.nextBillingDate).getDay()
            currentSubObj["deliveryDate"] = new Date(new Date().setDate(new Date(data.nextBillingDate).getDate()+4)).getDay()
            currentSubObj["currentSubID"] = subscriptionIdentifier
            currentSubObj["postalCode"] = data.deliveryMethod.address.zip
            handleWarning()
          }
        })
    })
  })
}) ();
const getNextDay = (dayName) => {
  var date = new Date();
  
  var now = date.getDay();
  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var day = days.indexOf(dayName.toLowerCase());
  var diff = day - now;
  if(diff == 0 && date.getHours()<17){
    diff = 0;
  }else{
  diff = diff < 1 ? 7 + diff : diff;
  }
  
  var nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * diff);
  return new Date(nextDayTimestamp).toLocaleDateString('sv-SE')
}; 
/* currently getNextDayInterval is not used. The idea was to create a function which could handle the currently scheduled billing day as they current day. The getNextDay function just finds the upcoming day, it does not use the billing day */
const getNextDayInterval = (dayName, originate) => {
  var date = new Date(originate);
  
  var now = date.getDay();
  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var day = days.indexOf(dayName.toLowerCase());
  var diff = day - now;
  diff = diff < 1 ? 7 + diff : diff;
  var nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * diff);
  return new Date(nextDayTimestamp).toLocaleDateString('sv-SE')
};

usureClose = () => {
  let usure = document.querySelector('#skipNotice');
  usure.classList.add('skipHidden');
}
usure = () => {
  // window.location.href = "https://inspiredgo.ca/apps/subscriptions"
  // window.location.href = "https://inspiredgo.ca/apps/subscriptions"
  let usure = document.querySelector('#skipNotice');
  usure.classList.toggle('skipHidden');
}
skipLoad = () => {
  skipElement = document.querySelector("#loading");
  skipElement.classList.add("skipLoading");
};
changeLoad = () => {
  const changeElement = document.querySelector("#changeNotice");
  changeElement.classList.add("skipLoading");
};
// uChangeClose = () => {
//   let usure = document.querySelector('#changeNotice');
//   usure.style.display = "none";
// }
uChange = () => {

 document.querySelector("menu-wrapper").open_modal_change_delivery()
  }
subChangeLoad = () => {
  skipElement = document.querySelector("#loading");
  skipElement.classList.add("changeLoading");
};
skipButton = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
  };
  var skipOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
  }
  skipLoad();;
  var res = {};
  res = await fetch(location.origin + `/apps/subscriptions?action=customer_payment_token&customer_id=${window.customer.id}`)
  res = await res.json();
  if (typeof window.clarity === 'function') {
  window.clarity("set", "subscriber_action", "skipped_order")
  }
  let nextOrderId;
  var x = currentSubObj.currentSubID;
  x = (token+x).replace('\n','')
  var hash = CryptoJS.MD5(x).toString();
  var headers ={'headers':
  // APPSTLE REMOVED: Appstle external token disabled
  // {'externalauthorization':`Bearer ${res.appstleExternalToken}`,"Content-Type": "application/json","accept": "application/json, text/plain, */*"},'method':'GET'}
  {"Content-Type": "application/json","accept": "application/json, text/plain, */*"},'method':'GET'}

  fetch(`${url}cp/api/subscription-billing-attempts/top-orders?hash=${hash}&email=${window.customer.email}&contractId=` + currentSubObj.currentSubID + "&customerId=" +  window.customer.id,headers)
  //var x = currentSubObj.currentSubID;
  //x = (token+x).replace('\n','')
  //var hash = CryptoJS.MD5(x).toString();
  //fetch(`${url}external/v2/subscription-billing-attempts/top-orders?hash=${hash}&email=${window.customer.email}&hash=${hash}&email=${window.customer.email}&contractId=` + currentSubObj.currentSubID + "&customerId=" +  window.customer.id )
    .then(response => response.json())
  .then((data) => nextOrderId = data[0].id)
  .then(() => {
     x = (token+nextOrderId).replace('\n','')
    hash = CryptoJS.MD5(x).toString();
    // APPSTLE REMOVED: Appstle external token disabled
    // skipOptions['headers']['externalauthorization']=`Bearer ${res.appstleExternalToken}`
    return fetch(`${url}cp/api/subscription-billing-attempts/skip-order/` + nextOrderId + `?hash=${hash}&isExternal=true&email=${window.customer.email}&id=` + nextOrderId + "&subscriptionContractId=" + currentSubObj.currentSubID + "&isPrepaid=false", skipOptions)
  })
  .then(() => location.href = "https://inspiredgo.ca/collections/all?subscription=order_was_skipped");
}



